import React from 'react';
import {
  Box,
  Button,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import grey from '@mui/material/colors/grey';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    backgroundColor: grey[100],
    backgroundClip: 'content-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(-3),
    marginLeft: theme.spacing(-3),
    marginRight: theme.spacing(-3),
  },
}));


/**
 * Edit display settings dialog (for bulk actions)
 * @param open
 * @param onClose
 * @param selectedCount
 * @param displaySettings
 * @param setDisplaySettings
 * @param onSave
 * @return {Element}
 * @constructor
 */
const EditDisplaySettingsDialog = ({
  open,
  onClose,
  selectedCount,
  displaySettings,
  setDisplaySettings,
  onSave
}) => {
  const classes = useStyles();
  const handleChange = (field) => (event) => {
    setDisplaySettings((prev) => ({
      ...prev,
      [field]: event.target.value === 'yes',
    }));
  };

  const labels = {
    searchField: 'Search field',
    filter: 'Filter',
    region: 'Region',
  };
  const labelKeys = Object.keys(labels);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="persistent"
      PaperProps={{
        sx: { width: 360, boxSizing: 'border-box', p: 3 },
      }}
    >
      <Box className={classes.dialogTitle}>
        <Typography variant="h5" sx={{ p: 3, fontWeight: "500" }}>Edit display settings</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography variant="body" sx={{ px: 2, mt: 1 }}>
        <Typography component="span" sx={{ fontWeight: 600, display: 'inline' }}>
          {selectedCount}
        </Typography>{' '}
        itineraries selected
      </Typography>

      <Paper variant="outlined" sx={{ px: 2, pt: 1, mt: 2 }}>
        <Typography variant="body1" gutterBottom>
          Display itineraries in:
        </Typography>

        <Divider sx={{ mb: 1 }} />

        {labelKeys.map((key) => (
          <Box key={key} sx={{ display: 'flex', alignItems: 'center' }} variant="">
            <Typography
              variant="body1"
              sx={{ fontWeight: 600, width: 100, flexShrink: 0 }}
            >
              {labels[key]}
            </Typography>

            <RadioGroup
              row
              defaultValue="yes"
              onChange={handleChange(key)}
              sx={{ ml: 2 }}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes"/>
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </Box>
        ))}
      </Paper>


      <Box mt={4}>
        <img
          src="/display-settings-legend.png"
          alt="Display preview"
          style={{ width: '100%', borderRadius: 8 }}
        />
      </Box>

      <Box mt="auto" pt={4} display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          sx={{ textTransform: 'none' }}
        >
          <SaveIcon/>
          Save
        </Button>
      </Box>
    </Drawer>
  );
};

export default EditDisplaySettingsDialog;
